<template>
    <div v-if="error || errorMessage">
        <p class="error-message">{{ errorMessage || 'Wait times are not available right now.' }}</p>
    </div>
     <div v-else-if="waitTime === null || waitTime === '' || waitTime === undefined">
        <p class="error-message"><em>Retrieving wait time....</em></p>
    </div>

    <div v-else>
        <div class="row">
            <p class="margin-mar1">
                <span class="icon-position-middle" v-if="statusClass === 'status-green'">
                    <img src="assets/checkmark_icon.svg" alt="Available" />
                </span>
                <span class="icon-position-middle" v-else-if="statusClass === 'status-orange'">
                    <img src="assets/busy_icon.svg" alt="Busy" />
                </span>
                <span class="icon-position-middle" v-else-if="statusClass === 'status-red'">
                    <img src="assets/notavailable_icon.svg" alt="Not Available" />
                </span>
                <span :style="{
                    color: statusClass === 'status-green' ? 'rgb(45, 122, 45)' : statusClass === 'status-orange' ? '#f9a825' : statusClass === 'status-red' ? '#d32f2f' : '#333'
                }">{{ statusMessage }}</span>
                <br>
            </p>

        </div>
        <div class="row" v-if="statusClass !== 'status-red'" :class="statusClass">
            <div class="tile-main">

                <div class="tile-wait" v-if="showWaitTime">
                    <span class="row wait-label">Estimated Wait</span>
                    <span class="row wait-value">{{ waitTimeRange(this.waitTime) }}</span>
                </div>

            </div>
        </div>
        <br />
    </div>
</template>
<script>
import { waitTimeRange } from '../actions/waitTimeActions';

export default {
    name: "WaitTimeCard",
    data() {
        return {
            showDisclaimerTooltip: false
        };
    },
    props: {
        title: {
            type: String,
            required: false,
            default: ''
        },
        waitTime: {
            type: [String, Number],
            required: false,
            default: null
        },
        capacity: {
            type: [String, Number],
            required: false,
            default: null
        },
        lastUpdated: {
            type: String,
            required: false,
            default: ''
        },
        error: {
            type: Boolean,
            required: false,
            default: false
        },
        errorMessage: {
            type: String,
            required: false,
            default: ''
        }
    },
    methods: {
        waitTimeRange,
        toggleDisclaimer() {
            this.showDisclaimerTooltip = !this.showDisclaimerTooltip;
        },
        parseWaitTimeToMinutes(waitTime) {
            if (!waitTime || typeof waitTime !== 'string') return null;
            const parts = waitTime.split(':');
            if (parts.length !== 3) return null;
            const [hh, mm, ss] = parts.map(Number);
            if (isNaN(hh) || isNaN(mm) || isNaN(ss)) return null;
            return hh * 60 + mm + (ss > 0 ? 1 : 0); // round up if any seconds
        }
    },
    computed: {
        statusClass() {
            if (this.capacity !== null && Number(this.capacity) >= 90) {
                return 'status-red';
            }
            const mins = this.parseWaitTimeToMinutes(this.waitTime);
            if (mins !== null && mins > 45) {
                return 'status-orange';
            }
            if (mins !== null && mins <= 45) {
                return 'status-green';
            }
            return '';
        },
        iconColor() {
            if (this.statusClass === 'status-red') return '#d32f2f';
            if (this.statusClass === 'status-orange') return '#f9a825';
            if (this.statusClass === 'status-green') return '#388e3c';
            return '#888';
        },
        statusMessage() {
            if (this.capacity !== null && Number(this.capacity) >= 90) {
                return 'At Capacity — please try another office';
            }
            const mins = this.parseWaitTimeToMinutes(this.waitTime);
            if (mins !== null && mins > 45) {
                return 'Busy — longer waits expected';
            }
            if (mins !== null && mins <= 45) {
                return 'Accepting walk-ins & appointments';
            }
            return '';
        },
        showWaitTime() {
            // Only show wait time if not at capacity
            return !(this.capacity !== null && Number(this.capacity) >= 90) && this.waitTime !== null && this.waitTime !== undefined;
        },
        formattedTime() {
            // Only show time part (HH:mm:ss) from lastUpdated
            if (!this.lastUpdated) return '';
            // Try to extract time from ISO or 'YYYY-MM-DD HH:mm:ss' or similar
            const match = this.lastUpdated.match(/(\d{2}:\d{2}:\d{2})/);
            return match ? match[1] : this.lastUpdated;
        },
    }
};
</script>


<style scoped>
.disclaimer-tooltip {
    cursor: pointer;
    display: inline-block;
    position: relative;
}

.disclaimer-tooltip-content {
    position: absolute;
    top: 120%;
    right: 0;
    z-index: 10;
    background: #fff;
    color: #333;
    border: 1px solid #ccc;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    padding: 0.7em 1em;
    min-width: 220px;
    font-size: 0.95em;
    white-space: normal;
    text-align: left;
}

.wait-time-tile {
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 40%;
    min-height: 90px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.10);
    padding: 0.5rem 1rem 0.5rem 0.5rem;
    font-family: inherit;
    transition: box-shadow 0.2s;
}

.wait-time-tile.status-green {
    border-left: 6px solid rgb(45, 122, 45);
}

.wait-time-tile.status-orange {
    border-left: 6px solid #f9a825;
}

.wait-time-tile.status-red {
    border-left: 6px solid #d32f2f;
}

.tile-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex: 1 1 auto;
}

.tile-icon {
    flex: 0 0 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 0.7rem;
}

.tile-main {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 2rem;
}

.tile-title {
    font-size: 1.05rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 0.2rem;
}

.tile-status-message {
    font-size: 0.7rem;
    font-weight: 500;
    margin-bottom: 0.2rem;
    color: #333;
    padding: 0px;
    text-align: right;
}

.wait-label {
    font-size: 0.8rem;
    margin-right: 0.3rem;
    font-weight: normal;
}

.wait-value {
    font-size: 1.3rem;
    color: black;
    font-weight: bold;
}

.color-orange {
    color: #f9a825;
}

.color-green {
    color: #2d7a2d;
}

.color-red {
    color: #d32f2f;
    font-weight: bold;
    padding: 0px;
    display: block;
    font-size: 1rem;
}

.tile-wait {
    font-size: 1.3rem;
    font-weight: 700;
    margin-bottom: 0.1rem;
}

.tile-capacity {
    font-size: 0.95rem;
    color: #555;
}

.capacity-label {
    font-size: 0.85rem;
    color: #888;
    margin-right: 0.2rem;
}

.capacity-value {
    font-size: 1rem;
    color: #555;
}

.tile-footer {
    font-size: 0.7rem;
    color: #525252;
    text-align: right;
    margin-top: 0.2rem;
}

.margin-mar1 {
    margin: 1rem;
}

.icon-position-middle {
    vertical-align: middle;
    display: inline-flex;
    align-items: center;
}

.icon-position-middle img {
    width: 20px;
    height: 20px;
    max-width: 20px;
    max-height: 20px;
    margin-bottom: .5rem;
}
.error-message {
    padding-top: 1rem;
}
</style>
